module.exports = __webpack_public_path__ + "static/media/banner1.23eee0e6.png";